import {createFeatureSelector, MemoizedSelector} from '@ngrx/store';
import {CustomUnavailableProductsListState, UNAVAILABLE_PRODUCTS_FEATURE, StateWithUnavailableProducts} from '../custom-unavailable-products-state';


export const getUnavailableProductsListState: MemoizedSelector<StateWithUnavailableProducts,
  CustomUnavailableProductsListState> = createFeatureSelector<CustomUnavailableProductsListState>(UNAVAILABLE_PRODUCTS_FEATURE);
